var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnInit } from '@angular/core';
import { ListingsService } from '../../../services/listings.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { PreferencesService } from '../../../services/preferences.service';
import { UserService } from '../../../services/user.service';
import { HistoryItem } from '../../../classes/history-item';
import { RoutingHistoryService } from '../../../services/routing-history.service';
var FavouriteListingsComponent = /** @class */ (function (_super) {
    __extends(FavouriteListingsComponent, _super);
    function FavouriteListingsComponent(listingsService, _preferencesService, userService, _historyService) {
        var _this = _super.call(this) || this;
        _this.listingsService = listingsService;
        _this._preferencesService = _preferencesService;
        _this.userService = userService;
        _this._historyService = _historyService;
        _this.wentToFindSome = new EventEmitter();
        _this.favourites = [];
        return _this;
    }
    FavouriteListingsComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.addSub(this._preferencesService.favouriteListingsChanged.subscribe(function (favIds) { return __awaiter(_this, void 0, void 0, function () {
                    var response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.listingsService.getListingsPreview(favIds.join(',')).catch(function (error) { return null; })];
                            case 1:
                                response = _a.sent();
                                if (response === null || response.results === null || response.results.length === 0) {
                                    this.favourites = [];
                                }
                                else {
                                    response.results.forEach(function (part, index, theArray) { return theArray[index].isFavourite = true; });
                                    this.favourites = response.results;
                                }
                                return [2 /*return*/];
                        }
                    });
                }); }));
                this.addSub(this.userService.currentUser.subscribe(function (user) { return _this._historyService.push(new HistoryItem({ fromFavouritesPage: true })); }));
                return [2 /*return*/];
            });
        });
    };
    FavouriteListingsComponent.prototype.onFavouriteClicked = function (listing) {
        return __awaiter(this, void 0, void 0, function () {
            var offset;
            return __generator(this, function (_a) {
                offset = this.favourites.findIndex(function (fav) { return fav === listing; });
                // We always start at 0 offset on since we only return elements after the one selected
                this._preferencesService.addNextListings(this.favourites.slice(offset, this.favourites.length).map(function (l) { return ({ listingId: l.listingId, detailUrl: l.detailUrl }); }));
                return [2 /*return*/];
            });
        });
    };
    return FavouriteListingsComponent;
}(HasSubscriptions));
export { FavouriteListingsComponent };
